// Wrapped so nothing here becomes a global lexical binding: these load as
// classic `defer` scripts, and a top-level `const`/`class` name colliding with
// another theme script is a parse-time SyntaxError that kills the whole file.
(() => {
  class HiraAccordionRow extends HTMLElement {
    constructor() {
      super();
      this._onHeaderClick = this._onHeaderClick.bind(this);
    }

    connectedCallback() {
      this._header = this.querySelector('.hira-accordion__header');
      this._panel = this.querySelector('.hira-accordion__panel');

      if (!this._header || !this._panel) return;

      this._header.addEventListener('click', this._onHeaderClick);
    }

    disconnectedCallback() {
      this._header?.removeEventListener('click', this._onHeaderClick);
    }

    _onHeaderClick() {
      this.toggle();
    }

    get isOpen() {
      return this._header?.getAttribute('aria-expanded') === 'true';
    }

    open() {
      if (!this._header) return;
      this._header.setAttribute('aria-expanded', 'true');
      this.dispatchEvent(new CustomEvent('hira-accordion:open', { bubbles: true }));
    }

    close() {
      if (!this._header) return;
      this._header.setAttribute('aria-expanded', 'false');
    }

    toggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }
  }

  class HiraAccordion extends HTMLElement {
    constructor() {
      super();
      this._onChildOpen = this._onChildOpen.bind(this);
    }

    connectedCallback() {
      if (this.hasAttribute('single-open')) {
        this.addEventListener('hira-accordion:open', this._onChildOpen);
      }

      if (this.hasAttribute('open-first')) {
        const firstRow = this.querySelector(':scope > hira-accordion-row');
        firstRow?.open();
      }
    }

    disconnectedCallback() {
      this.removeEventListener('hira-accordion:open', this._onChildOpen);
    }

    _onChildOpen(event) {
      const rows = this.querySelectorAll(':scope > hira-accordion-row');
      for (const row of rows) {
        if (row !== event.target) row.close();
      }
    }
  }

  if (!customElements.get('hira-accordion-row')) {
    customElements.define('hira-accordion-row', HiraAccordionRow);
  }

  if (!customElements.get('hira-accordion')) {
    customElements.define('hira-accordion', HiraAccordion);
  }
})();
